import { CircularProgress, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import * as React from "react";
import { usePolicy } from "../../hooks";
import ContentPage from "../ContentPage";
import generateTableOfContents from "./tocUtils";
import styles from "./PolicyPage.module.css";
import TableOfContents from "./TableOfContents";

export default function PolicyPage({ slug }) {
  const { policy, isLoading, isError } = usePolicy(slug);

  const { toc, html } = React.useMemo(
    () => generateTableOfContents(policy?.content),
    [policy?.content],
  );

  if (isLoading) {
    return (
      <ContentPage title="Loading...">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "3rem 0",
          }}
        >
          <CircularProgress />
        </div>
      </ContentPage>
    );
  }

  if (isError || !policy) {
    return (
      <ContentPage title="Page Not Found">
        <Typography variant="body1" color="textSecondary">
          The requested policy page could not be found.
        </Typography>
      </ContentPage>
    );
  }

  return (
    <ContentPage title={policy.title} description={policy.metaDescription}>
      <div>
        <TableOfContents entries={toc} />
        <div
          className={styles.prose}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    </ContentPage>
  );
}

PolicyPage.propTypes = {
  slug: PropTypes.string.isRequired,
};
